// Copyright (c) Docugami, Inc. All rights reserved.
import { UrlHashParametersState, SET_URL_HASH_PARAMETERS_STATE } from "./types";

const initialState: UrlHashParametersState = {
    hash: '',
    query: '',
    dictionary: {}
};

export function urlHashParametersReducer(
    state = initialState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any
): UrlHashParametersState 
{
    switch (action.type) 
    {
        case SET_URL_HASH_PARAMETERS_STATE: 
        {
            return { ...action.payload };
        }
        default:
            return state;
    }
}
